module.exports = __webpack_public_path__ + "img/whiteAlbum2.74110ba6.jpg";